import reducer from './reducers';
import { createStore, applyMiddleware, compose } from 'redux';
import { axiosMiddleware } from './middleware';

let composeEnhancers =  compose;
if (typeof window !== 'undefined'){
    composeEnhancers =  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}
const configureStore = (initialState) => {
    const store = createStore(reducer, initialState, composeEnhancers(
        applyMiddleware(axiosMiddleware)
    ));
    return store;
};

export default configureStore;


// WEBPACK FOOTER //
// ../q-cars/src/redux/store.js